import { useEffect } from "react";

interface FarmData {
  farm_id: string;
  farm_name: string;
  country?: string;
  county?: string;
  region?: string;
  locations?: {
    boundary?: string;
    center?: string;
  };
}

const useFetchFarms = (
  token: string,
  signInStatus: string,
  setDbFarms: (farms: FarmData[]) => void
) => {
  useEffect(() => {
    if (signInStatus !== "SIGNED_IN") {
      return;
    }
    
    const fetchFarms = async () => {
      try {
        const params = new URLSearchParams();

        const response = await fetch(
          `${import.meta.env.VITE_AWS_LAMBDA_API}list-farms?${params}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        setDbFarms(typeof data === "object" ? data.data : []);
      } catch (error) {
        console.error("FetchFarms:", error);
        setDbFarms([]);
      }
    };

    fetchFarms();
  }, [signInStatus, token]);
};

export default useFetchFarms;

